const resumeStyles = {
  section: {
    background: "#233",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  heading: {
    color: "tomato",
    padding: "3rem 0",
    textTransform: "uppercase",
  },
  timeline: {
    position: "relative",
    zIndex: 1,
    padding: "clamp(0.75rem, 1.5vh, 2rem)",
    margin: "0 auto",
    flex: 1,
    overflowY: "auto",
    maxHeight: "calc(100vh - 120px)",
    "& .MuiTypography-h2": {
      fontSize: "clamp(1.2rem, 2vw, 1.8rem)",
      lineHeight: 1.1,
    },
    "& .MuiTypography-h5": {
      fontSize: "clamp(0.95rem, 1.5vw, 1.25rem)",
      lineHeight: 1.2,
    },
    "& .MuiTypography-body1": {
      fontSize: "clamp(0.8rem, 1.2vw, 1rem)",
      lineHeight: 1.3,
    },
    "& .MuiTypography-subtitle1": {
      fontSize: "clamp(0.75rem, 1.1vw, 0.95rem)",
      lineHeight: 1.3,
    },
    "&:before": {
      display: "none",
    },
    "&:after": {
      content: "''",
      display: "table",
      clear: "both",
    },
    "@media (min-width:900px)": {
      padding: "2rem",
      backgroundImage:
        "linear-gradient(to right, transparent calc(50% - 1px), tan calc(50% - 1px), tan calc(50% + 1px), transparent calc(50% + 1px))",
      backgroundRepeat: "repeat-y",
      backgroundSize: "100% 100%",
    },
    "@media (max-height:800px)": {
      padding: "0.5rem",
    },
  },
  year: {
    textAlign: "center",
    maxWidth: "9.375rem",
    margin: "0 3rem 0 auto",
    fontSize: "1.8rem",
    color: "#fff",
    background: "tomato",
    lineHeight: 1,
    padding: "0.5rem 1rem",
    position: "relative",
    "&:before": { display: "none" },
    "@media (min-width:900px)": {
      textAlign: "center",
      margin: "0 auto",
      "&:nth-of-type(2n)": {
        float: "none",
        margin: "0 auto",
      },
      "&:nth-of-type(2n):before": {
        display: "none",
      },
    },
    paddingX: "1rem",
    clear: "both",
  },
  item: {
    padding: "1rem",
    borderBottom: "2px solid tan",
    position: "relative",
    margin: "1rem 3rem 1rem 1rem",
    clear: "both",
    "&:after": {
      content: "''",
      position: "absolute",
    },
    "@media (min-width:900px)": {
      width: "44%",
      margin: "1rem",
      "&:nth-of-type(2n)": {
        float: "right",
        margin: "1rem",
        borderColor: "tan",
      },
    },
  },
  itemLeft: {
    "&:before": {
      content: "''",
      position: "absolute",
      right: "-0.5rem",
      top: "calc(50% - 8px)",
      borderStyle: "solid",
      borderWidth: "8px 0 8px 8px",
      borderColor: "transparent transparent transparent tomato",
    },
  },
  itemRight: {
    "@media (min-width:900px)": {
      float: "right",
    },
    "&:before": {
      content: "''",
      position: "absolute",
      left: "-0.5rem",
      top: "calc(50% - 8px)",
      borderStyle: "solid",
      borderWidth: "8px 8px 8px 0",
      borderColor: "transparent tomato transparent transparent",
    },
  },
  title: {
    color: "#fff",
    padding: 0,
    textTransform: "uppercase",
  },
  company: {
    color: "tomato",
  },
  description: {
    color: "tan",
  },
};

export default resumeStyles;
